<template>
  <div class="about" style="position: relative">
    <NavBar/>
    <section
      class="d-flex align-items-center"
      style="min-height: calc(100vh - 150px)"
    >
      <b-container>
        <b-row>
          <b-col :class="['terms-text', 'with-top-bar', isHebrew ? 'text-right' : 'text-left']" :dir="isHebrew ? 'rtl' : 'ltr'">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h1 class="main-ride-titles mb-0">{{ t('termsOfUseTitle') }}</h1>
              <b-button variant="primary" size="lg" @click="goBack" class="back-button" :dir="isHebrew ? 'rtl' : 'ltr'">
                <i :class="isHebrew ? 'fas fa-arrow-right' : 'fas fa-arrow-left'"></i>
                {{ t('backToPrevious') }}
              </b-button>
            </div>

            <p>
              {{ t('termsIntro') }}
            </p>

            <h3>{{ t('sharingTripsTitle') }}</h3>
            <p>
              {{ t('sharingTripsContent') }}
            </p>

            <h3>{{ t('notProfessionalAdviceTitle') }}</h3>
            <p>
              {{ t('notProfessionalAdviceContent') }}
            </p>

            <h3>{{ t('professionalServicesTitle') }}</h3>
            <p>
              {{ t('professionalServicesContent') }}
            </p>

            <h3>{{ t('clientViewingTitle') }}</h3>
            <p>
              {{ t('clientViewingContent1') }}
              {{ t('clientViewingContent2') }}
            </p>

            <h3>{{ t('noContentGuaranteeTitle') }}</h3>
            <p>
              {{ t('noContentGuaranteeContent1') }}
              {{ t('noContentGuaranteeContent2') }}
            </p>

            <h3>{{ t('marketingContentTitle') }}</h3>
            <p>
              {{ t('marketingContentContent') }}
            </p>

            <h3>{{ t('liabilityLimitationTitle') }}</h3>
            <p>
              {{ t('liabilityLimitationContent') }}
            </p>

            <h3>{{ t('siteUsageTitle') }}</h3>
            <p>
              {{ t('siteUsageContent') }}
            </p>

            <h3>{{ t('copyrightTitle') }}</h3>
            <p>
              {{ t('copyrightContent') }}
            </p>

            <h3>{{ t('accessibilityTitle') }}</h3>
            <p>
              {{ t('accessibilityContent1') }}
            </p>
            <p>
              {{ t('accessibilityContent2') }}
            </p>
            <p>
              {{ t('accessibilityContent3') }}
            </p>

            <h3>{{ t('changesTitle') }}</h3>
            <p>
              {{ t('changesContent') }}
            </p>

            <h3>{{ t('contactTitle') }}</h3>
            <p>
              {{ t('contactContent') }}
              <a href="mailto:avshalom@tripplanner.co.il">avshalom@tripplanner.co.il</a>
            </p>

            <h4 style="margin-top: 3rem;">{{ t('lastUpdated') }}</h4>

            <div class="d-flex justify-content-start mt-4 mb-4">
              <b-button variant="primary" size="lg" @click="goBack" class="back-button" :dir="isHebrew ? 'rtl' : 'ltr'">
                <i :class="isHebrew ? 'fas fa-arrow-right' : 'fas fa-arrow-left'"></i>
                {{ t('backToPrevious') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <PageFooter v-if="!isSubdomain" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';
import PageFooter from "@/components/PageFooter.vue";
import NavBar from "@/components/NavBar.vue";

export default {
  name: "TermsOfUse",
  mixins: [translationMixin],
  components: {
    NavBar,
    PageFooter,
  },
  computed: { ...mapGetters(['globalRides', 'userId']),
              ...mapGetters("theme",  [ "isSubdomain",
                                      ]),
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.with-top-bar {
  margin-top: 50px;
}

.terms-text {
  font-style: normal;
  font-size: 1.5rem;
  line-height: 2.2rem;
  letter-spacing: 0.03em;
  color: #212529;
}
.main-ride-titles {
  color: #07A0C3;
  margin-bottom: 2rem;
}
.terms-text h3 {
  font-weight: bold;
  color: #07A0C3;
  margin-top: 2rem;
}
.terms-text a {
  color: #007bff;
  text-decoration: underline;
}
.back-button {
  font-size: 1.6rem;
  padding: 0.8rem 2rem;
  margin: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  background-color: #07A0C3;
  border-color: #07A0C3;
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: #0588A7;
  border-color: #0588A7;
}

.back-button i {
  font-size: 1.4rem;
  margin-left: 0.8rem;
}

/* Language toggle positioning */
.language-toggle-container {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 1000;
}

/* Language-specific text alignment */
.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

/* Language-specific button icon spacing */
.back-button[dir="ltr"] i {
  margin-left: 0;
  margin-right: 0.8rem;
}

.back-button[dir="rtl"] i {
  margin-left: 0.8rem;
  margin-right: 0;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .with-top-bar {
    margin-top: 20px;
  }
  
  .terms-text {
    font-size: 1.1rem !important;
    line-height: 1.6rem !important;
    padding: 0 10px;
  }
  
  .main-ride-titles {
    font-size: 1.3rem !important;
    margin-bottom: 1rem !important;
  }
  
  .terms-text h3 {
    font-size: 1.2rem !important;
    margin-top: 1.5rem !important;
    margin-bottom: 0.8rem !important;
  }
  
  .back-button {
    font-size: 1.2rem !important;
    padding: 0.6rem 1.2rem !important;
    margin: 0.5rem 0 !important;
  }
  
  .back-button i {
    font-size: 1.1rem !important;
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
  
  .d-flex.justify-content-between {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  
  .d-flex.justify-content-start {
    justify-content: center !important;
  }
  
  .language-toggle-container {
    top: 60px;
    right: 10px;
  }
  
  /* Better spacing for mobile */
  section {
    padding: 20px 0 !important;
  }
  
  .container {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

@media (max-width: 480px) {
  .terms-text {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
    padding: 0 5px;
  }
  
  .main-ride-titles {
    font-size: 1.1rem !important;
  }
  
  .terms-text h3 {
    font-size: 1.1rem !important;
  }
  
  .back-button {
    font-size: 1rem !important;
    padding: 0.5rem 1rem !important;
    width: 100%;
    margin: 0.5rem 0 !important;
  }
  
  .language-toggle-container {
    top: 50px;
    right: 5px;
  }
  
  .language-toggle-container .language-toggle .language-btn {
    font-size: 10px !important;
    padding: 2px 6px !important;
  }
}
</style>
